<template>
  <va-card title="Credentials">
    <div class="credentials-body">
      <div class="credential-logo-container">
        <img src="../../assets/cpdt-ka-color-med.png" alt="CPDT-KA logo" />
      </div>
      <div v-if="isFearFreeCertified" class="credential-csat-container">
        <img src="../../assets/csat.png" alt="CSAT logo" />
      </div>
      <div v-if="isCSAT" class="credential-fear-free-container">
        <img src="../../assets/fear-free.png" alt="Fear Free logo" />
      </div>
      <div v-if="isPPGMember" class="credential-ppg-container">
        <img src="../../assets/ppg.png" alt="Pet Professional Guild logo" />
      </div>
    </div>
  </va-card>
</template>

<script>

export default {
  name: 'credentials-card',
  data () {
    return {
      isPPGMember: false,
      isFearFreeCertified: true,
      isCSAT: true,
    }
  },
}
</script>

<style scoped lang="scss">
  .credentials-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .credential-logo-container,
    .credential-fear-free-container {
      display: flex;
      justify-content: center;
      width: 80%;
      margin-bottom: 24px;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  @include media-breakpoint-up(lg) {
    .credentials-body {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .credential-logo-container,
      .credential-fear-free-container {
        display: flex;
        justify-content: center;
        width: 40%;
        margin-bottom: 24px;
        overflow: hidden;
      }
    }
  }
</style>
